import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Municipio } from "@/models/gessan/municipio";
import { GessanApiEnvelope, TipoDocumentoGessan } from "@/models/gessan/tipoDocumento";
import { Pagination } from "@/models/sit-pedido/pagination";
import { SaneamentoApi } from "@/api/gessan/saneamento.api";
import { PaginationTableSaneamento } from "@/store/modules/gessan/states/table";
import { Lista } from "@/models/gessan/lista";

const api = new SaneamentoApi();

const getList = (
  filter: PaginationTableSaneamento,
  isGrupo?: boolean
): AxiosObservable<Pagination<Lista>> => {
  return api.getList(filter, isGrupo);
};

const cadastro = (formData: FormData, isGrupo?: boolean): AxiosObservable<any> => {
  return api.cadastro(formData, isGrupo);
};

const downloadDAE = (id: string): AxiosObservable<Blob> => {
  return api.downloadDAE(id);
};

const getMunicipioLogado = (cnpj: string): AxiosObservable<Municipio> => {
  return api.getMunicipioLogado(cnpj);
};

const findByCnpjToken = (cnpj: string, token: string): AxiosObservable<Municipio> => {
  return api.findByCnpjToken(cnpj, token);
};

const getTiposDocumento = (
  cnpj: string,
  isGrupo: boolean
): AxiosObservable<GessanApiEnvelope<TipoDocumentoGessan[]>> => {
  return api.getTiposDocumento(cnpj, isGrupo);
};

const getSituacoes = (cnpj: string, isGrupo?: boolean): AxiosObservable<string[]> => {
  return api.getSituacoes(cnpj, isGrupo);
};

const historicoCentral = (form: {
  cnpj: string;
  nomeResponsavel: string;
  cpfResponsavel: string;
  aceite: boolean;
  competencia: string;
}) => {
  return api.historicoCentral(form);
};

const downloadQuitacao = (
  id: number,
  cnpj: string,
  isGrupo?: boolean
): AxiosObservable<any> => {
  return api.downloadQuitacao(id, cnpj, isGrupo);
};

const listaNegadosCancelados = (
  cnpj: string,
  isGrupo?: boolean
): AxiosObservable<any> => {
  return api.listaNegadosCancelados(cnpj, isGrupo);
};

const downloadDAEVencido = (
  nossoNumero: string,
  dataVencimento: string,
  cnpj: string,
  isGrupo?: boolean
): AxiosObservable<Blob> => {
  return api.downloadDAEVencido(nossoNumero, dataVencimento, cnpj, isGrupo);
};

const getSituacoesDAE = (cnpj: string, isGrupo?: boolean): AxiosObservable<string[]> => {
  return api.getSituacoesDAE(cnpj, isGrupo);
};

const podeCriarInformeService = (
  cnpj: string,
  isGrupo?: boolean
): AxiosObservable<boolean | GessanApiEnvelope<boolean>> => {
  return api.podeCriarInforme(cnpj, isGrupo);
};

export default {
  getList,
  getMunicipioLogado,
  findByCnpjToken,
  getTiposDocumento,
  getSituacoes,
  cadastro,
  downloadDAE,
  historicoCentral,
  downloadQuitacao,
  listaNegadosCancelados,
  downloadDAEVencido,
  getSituacoesDAE,
  podeCriarInformeService,
};
